// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7476e934","641":"6934fd33","844":"c75923a4"}[chunkId] + ".chunk.js";
};